// src/lib/stripe.js
// Stripe initialization (singleton). Stripe can crash if locale is invalid/undefined, so guard it before passing.
// CRITICAL: loadStripe must be called EXACTLY ONCE per page load to avoid message port errors.
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PK = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

// Force a known-safe locale to avoid RegisterClientLocalizationsError from Stripe internals.
const safeLocale = "en";

// Singleton: loadStripe runs once at module scope.
// React.StrictMode in dev will unmount/remount, but this module-scope variable
// ensures loadStripe promise is cached and reused, preventing duplicate initialization.
let stripeInitialized = false;
export const stripePromise = loadStripe(STRIPE_PK, { locale: safeLocale }).then(
  (stripe) => {
    if (!stripeInitialized) {
      stripeInitialized = true;
      console.log('[Stripe] Initialized once at module scope');
    }
    return stripe;
  },
  (err) => {
    console.error('[Stripe] Failed to initialize:', err);
    throw err;
  }
);
